export default "__VITE_ASSET__ac2eadc3__"